<template>
	<div>
		<div v-if="isMobileView && sidebarOpen" class="sidebar-overlay" @click="closeSidebar"></div>
		<aside class="app-sidebar" :class="{ 'is-mobile': isMobileView, 'is-open': sidebarOpen }">

			<div class="sidebar-brand">
				<div class="brand-icon">
					<b-icon icon="church" pack="mdi" custom-size="mdi-18px"></b-icon>
				</div>
				<div class="brand-text">
					<span class="brand-name">Grupos LLDM</span>
					<span class="brand-sub">Panel de control</span>
				</div>
				<button v-if="isMobileView" type="button" class="sidebar-close" @click="closeSidebar" aria-label="Cerrar menú">
					<b-icon icon="close" pack="mdi"></b-icon>
				</button>
			</div>

			<div class="nav-context">
				<p class="context-label">Grupo activo</p>
				<div class="context-card">
					<b-icon icon="office-building" pack="mdi" size="is-small"></b-icon>
					<div class="context-info">
						<strong>{{ grupoNombre || 'Todos los grupos' }}</strong>
						<span>{{ esSuper ? 'Vista de administrador' : 'Tu congregación' }}</span>
					</div>
				</div>
			</div>

			<nav class="menu">
				<p class="menu-label">Módulos</p>
				<ul class="menu-list">
					<li><router-link to="/" exact @click.native="handleNavClick"><b-icon icon="view-dashboard-outline" pack="mdi" size="is-small"></b-icon> Dashboard</router-link></li>
					<li><router-link to="/miembros" @click.native="handleNavClick"><b-icon icon="account-supervisor" size="is-small"></b-icon> Miembros</router-link></li>
					<li v-if="esSuper"><router-link to="/censo" @click.native="handleNavClick"><b-icon icon="home-group" pack="mdi" size="is-small"></b-icon> Censo</router-link></li>
					<li v-if="mostrarControlAsistencia"><router-link to="/control-asistencia" @click.native="handleNavClick"><b-icon icon="calendar-check" pack="mdi" size="is-small"></b-icon> Control de asistencia</router-link></li>
					<li v-if="mostrarEstadisticas"><router-link to="/estadistica-asistencias" @click.native="handleNavClick"><b-icon icon="chart-line" pack="mdi" size="is-small"></b-icon> Estadística de asistencias</router-link></li>
					<li v-if="esSuper"><router-link to="/multisucursal" @click.native="handleNavClick"><b-icon icon="office-building" pack="mdi" size="is-small"></b-icon> Grupos</router-link></li>
				</ul>

				<p class="menu-label">Administración</p>
				<ul class="menu-list">
					<li v-if="esSuper"><router-link to="/usuarios" @click.native="handleNavClick"><b-icon icon="account" size="is-small"></b-icon> Usuarios</router-link></li>
					<li v-if="esSuper"><router-link to="/roles" @click.native="handleNavClick"><b-icon icon="account-key" size="is-small"></b-icon> Roles</router-link></li>
					<li v-if="esSuper"><router-link to="/seleccionar-grupo" @click.native="handleNavClick"><b-icon icon="account-group" pack="mdi" size="is-small"></b-icon> Seleccionar grupo</router-link></li>
					<li v-if="esSuper"><router-link to="/configurar" @click.native="handleNavClick"><b-icon icon="cog-outline" pack="mdi" size="is-small"></b-icon> Configuración</router-link></li>
				</ul>
			</nav>

			<div class="sidebar-footer">
				<div class="status-row">
					<span class="status-dot"></span>
					<span>Conectado</span>
				</div>
				<div class="user-card">
					<div class="user-avatar">{{ iniciales }}</div>
					<div class="user-info">
						<strong>{{ usuarioNombre || 'Usuario' }}</strong>
						<span>{{ esSuper ? 'superadmin' : 'miembro' }}</span>
					</div>
				</div>
				<a class="logout-btn" @click="salir">
					<b-icon icon="logout" size="is-small"></b-icon> Cerrar sesión
				</a>
			</div>
		</aside>
	</div>
</template>

<script>
import AyudanteSesion from '@/Servicios/AyudanteSesion'
import HttpService from '@/Servicios/HttpService'

export default {
	name: 'AppSidebar',
	data(){
		return {
			esSuperLocal: AyudanteSesion.esSuper(),
			actuando: AyudanteSesion.actuandoComoGrupo(),
			esJefeLocal: false,
			sidebarOpen: false,
			isMobileView: false,
			usuarioNombre: '',
			grupoNombre: ''
		}
	},
	async mounted(){
		this.updateViewport()
		this.cargarDatosUsuario()
		this._onGrupoChanged = () => {
			this.esSuperLocal = AyudanteSesion.esSuper()
			this.actuando = AyudanteSesion.actuandoComoGrupo()
			this.cargarDatosUsuario()
			this.evaluarSiEsJefe()
		}
		this._onToggleSidebar = () => this.toggleSidebar()
		this._onResize = () => this.updateViewport()
		this._onKeyUp = (e) => { if(e && e.key === 'Escape') this.closeSidebar() }
		this._onBodyClassChange = () => {
			const body = document && document.body ? document.body : null
			if(body && body.classList && body.classList.contains('is-clipped')) this.closeSidebar()
		}

		if(typeof window !== 'undefined'){
			window.addEventListener('toggleSidebarMobile', this._onToggleSidebar)
			window.addEventListener('resize', this._onResize)
			window.addEventListener('keyup', this._onKeyUp)
		}

		if(typeof MutationObserver !== 'undefined' && typeof document !== 'undefined' && document.body){
			this._observer = new MutationObserver(this._onBodyClassChange)
			this._observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
		}

		window.addEventListener('grupoSeleccionadoChanged', this._onGrupoChanged)
		await this.evaluarSiEsJefe()
	},
	beforeDestroy(){
		window.removeEventListener('grupoSeleccionadoChanged', this._onGrupoChanged)
		if(typeof window !== 'undefined'){
			window.removeEventListener('toggleSidebarMobile', this._onToggleSidebar)
			window.removeEventListener('resize', this._onResize)
			window.removeEventListener('keyup', this._onKeyUp)
		}
		if(this._observer) this._observer.disconnect()
	},
	watch: {
		$route(){
			if(this.isMobileView) this.closeSidebar()
		},
		sidebarOpen(){
			this.applyBodySidebarClass()
		},
		isMobileView(){
			this.applyBodySidebarClass()
		}
	},
	methods: {
		cargarDatosUsuario(){
			const ses = AyudanteSesion.obtenerDatosSesion()
			this.usuarioNombre = (ses && ses.nombre) ? ses.nombre : (ses ? ses.usuario : '')
			this.grupoNombre = localStorage.getItem('grupoSeleccionadoNombre') || ''
		},
		salir(){
			AyudanteSesion.cerrarSesion()
		},
		applyBodySidebarClass(){
			if(typeof document === 'undefined' || !document.body) return
			document.body.classList.toggle('sidebar-open', this.sidebarOpen && !this.isMobileView)
			document.body.classList.toggle('sidebar-mobile-open', this.sidebarOpen && this.isMobileView)
		},
		updateViewport(){
			if(typeof window === 'undefined') return
			const prevMobile = this.isMobileView
			this.isMobileView = window.innerWidth <= 768
			if(prevMobile !== this.isMobileView){
				this.sidebarOpen = !this.isMobileView
			}
			this.applyBodySidebarClass()
		},
		toggleSidebar(){
			this.sidebarOpen = !this.sidebarOpen
			this.applyBodySidebarClass()
		},
		closeSidebar(){
			this.sidebarOpen = false
			this.applyBodySidebarClass()
		},
		handleNavClick(){
			if(this.isMobileView) this.closeSidebar()
		},
		async evaluarSiEsJefe(){
			if(AyudanteSesion.actuandoComoGrupo()){
				this.esJefeLocal = true
				return
			}
			const ses = AyudanteSesion.obtenerDatosSesion()
			if(!ses || !ses.id){ this.esJefeLocal = false; return }
			try{
				const usuario = await HttpService.obtenerConConsultas('usuarios.php', { accion: 'obtener_por_id', id: Number(ses.id) })
				if(!usuario) { this.esJefeLocal = false; return }
				const gid = usuario.grupoId || null
				if(!gid){ this.esJefeLocal = false; return }
				const grupo = await HttpService.obtenerConConsultas('grupos.php', { accion: 'obtener_por_id', id: Number(gid) })
				if(!grupo) { this.esJefeLocal = false; return }
				this.esJefeLocal = (String(grupo.jefe || '').trim() === String(usuario.nombre || '').trim())
			} catch(e){ console.error('Error comprobando jefe:', e); this.esJefeLocal = false }
		}
	},
	computed: {
		esSuper(){ return this.esSuperLocal && !this.actuando },
		mostrarControlAsistencia(){ return this.esJefeLocal || AyudanteSesion.actuandoComoGrupo() },
		mostrarEstadisticas(){
			const ses = AyudanteSesion.obtenerDatosSesion()
			return !!(this.esSuper || this.actuando || this.esJefeLocal || (ses && ses.grupoId))
		},
		iniciales(){
			const n = (this.usuarioNombre || 'U').trim()
			const partes = n.split(/\s+/)
			const ini = partes.slice(0, 2).map(p => p.charAt(0).toUpperCase()).join('')
			return ini || 'U'
		}
	}
}
</script>

<style scoped>
.app-sidebar{
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	width: var(--sidebar-width, 264px);
	background: #ffffff;
	border-right: 1px solid #e9ecf5;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 0;
	text-align: left;
	z-index: 1300;
	transition: transform .22s ease, box-shadow .22s ease;
	transform: translateX(-108%);
	display: flex;
	flex-direction: column;
}
.app-sidebar.is-open{
	transform: translateX(0);
}
.sidebar-overlay{
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(16, 24, 40, 0.55);
	backdrop-filter: blur(2px);
	z-index: 1250;
}
.sidebar-close{
	display: none;
	border: 1px solid #e9ecf5;
	background: #f8f9fd;
	border-radius: 9px;
	width: 34px; height: 34px;
	align-items: center; justify-content: center;
	color: #4b5267; cursor: pointer; flex-shrink: 0;
}
.sidebar-close:hover{ background: #fdeef1; color: #e11d48; }

/* Marca */
.sidebar-brand{
	display: flex;
	align-items: center;
	gap: .75rem;
	padding: 1.1rem 1.25rem 1rem;
}
.brand-icon{
	width: 38px;
	height: 38px;
	border-radius: 11px;
	background: linear-gradient(135deg, #7c5cff 0%, #5b3df0 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	box-shadow: 0 6px 14px -4px rgba(109, 74, 255, .45);
	flex-shrink: 0;
}
.brand-text{ display: flex; flex-direction: column; line-height: 1.25; }
.brand-name{ font-weight: 800; font-size: .98rem; color: #1b1f2e; letter-spacing: -.01em; }
.brand-sub{ font-size: .72rem; color: #8a90a6; font-weight: 500; }

/* Grupo activo */
.nav-context{ padding: .35rem 1rem .25rem; }
.context-label{
	font-size: .65rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: .08em;
	color: #9aa0b8;
	margin-bottom: .45rem;
}
.context-card{
	display: flex;
	align-items: center;
	gap: .6rem;
	background: #f6f7fd;
	border: 1px solid #eceef8;
	border-radius: 11px;
	padding: .6rem .75rem;
}
.context-card .icon{ color: #6d4aff; }
.context-info{ display: flex; flex-direction: column; line-height: 1.3; min-width: 0; }
.context-info strong{
	font-size: .82rem; color: #2a2f45; font-weight: 700;
	white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.context-info span{ font-size: .7rem; color: #8a90a6; }

/* Menú */
.menu{ padding: .75rem .8rem; margin: 0; flex: 1; }
.menu-label{
	font-size: .65rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: .08em;
	color: #9aa0b8;
	padding: .9rem .55rem .35rem;
	margin: 0;
}
.menu-list{ padding-left: 0; margin: 0; }
.menu-list a{
	color: #555d78;
	padding: .5rem .65rem;
	display: flex;
	align-items: center;
	gap: .65rem;
	justify-content: flex-start;
	border-radius: 9px;
	font-size: .86rem;
	font-weight: 500;
	transition: background .15s ease, color .15s ease;
}
.menu-list a .icon{ color: #9aa0b8; transition: color .15s ease; }
.menu-list a:hover{ background: #f6f4ff; color: #5b3df0; }
.menu-list a:hover .icon{ color: #6d4aff; }
.menu-list a.router-link-active,
.menu-list a.router-link-exact-active{
	background: #efecff;
	color: #5b3df0;
	font-weight: 700;
}
.menu-list a.router-link-active .icon,
.menu-list a.router-link-exact-active .icon{ color: #6d4aff; }
.app-sidebar .menu-list li + li{ margin-top: .1rem; }

/* Footer */
.sidebar-footer{
	border-top: 1px solid #eef0f7;
	padding: .85rem 1rem 1rem;
}
.status-row{
	display: flex;
	align-items: center;
	gap: .45rem;
	font-size: .75rem;
	font-weight: 600;
	color: #0a8f68;
	margin-bottom: .7rem;
}
.status-dot{
	width: 8px; height: 8px; border-radius: 999px;
	background: #10b981;
	box-shadow: 0 0 0 3px rgba(16,185,129,.18);
}
.user-card{
	display: flex;
	align-items: center;
	gap: .6rem;
	padding: .5rem .55rem;
	border-radius: 10px;
	background: #f8f9fd;
	margin-bottom: .55rem;
}
.user-avatar{
	width: 32px; height: 32px; border-radius: 999px;
	background: linear-gradient(135deg, #7c5cff, #a78bfa);
	color: #fff; font-size: .72rem; font-weight: 700;
	display: flex; align-items: center; justify-content: center;
	flex-shrink: 0;
}
.user-info{ display: flex; flex-direction: column; line-height: 1.25; min-width: 0; }
.user-info strong{ font-size: .8rem; color: #2a2f45; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.user-info span{ font-size: .68rem; color: #8a90a6; }
.logout-btn{
	display: flex;
	align-items: center;
	gap: .5rem;
	padding: .45rem .55rem;
	border-radius: 9px;
	color: #555d78;
	font-size: .82rem;
	font-weight: 500;
	transition: background .15s ease, color .15s ease;
}
.logout-btn:hover{ background: #fdeef1; color: #e11d48; }
.logout-btn:hover .icon{ color: #e11d48; }

@media (max-width: 768px){
	.app-sidebar{
		width: min(84vw, 290px);
		z-index: 1300;
		box-shadow: none;
		padding-top: var(--app-header-height);
	}
	.app-sidebar.is-open{
		transform: translateX(0);
		box-shadow: 0 22px 36px rgba(8, 15, 29, 0.22);
	}
	.sidebar-close{ display: inline-flex; }
}

@media (min-width: 769px){
	.app-sidebar{
		z-index: 1300;
		box-shadow: none;
	}
}
</style>
